import { render, staticRenderFns } from "./shipping-rate.vue?vue&type=template&id=7a39f5ba&scoped=true"
import script from "./shipping-rate.vue?vue&type=script&lang=js"
export * from "./shipping-rate.vue?vue&type=script&lang=js"
import style0 from "./shipping-rate.vue?vue&type=style&index=0&id=7a39f5ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a39f5ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a39f5ba')) {
      api.createRecord('7a39f5ba', component.options)
    } else {
      api.reload('7a39f5ba', component.options)
    }
    module.hot.accept("./shipping-rate.vue?vue&type=template&id=7a39f5ba&scoped=true", function () {
      api.rerender('7a39f5ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/shipping-rate.vue"
export default component.exports